import { MouseEventHandler, useCallback, useRef } from 'react';
import { useToggle } from 'react-use';
import { MdAdd } from 'react-icons/md';
import { CCShiftCellDropdown } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/components';
import { CCShiftOptionType } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/types';
import { CCShiftSelectPayload } from '@/api/apis/resources/schedule';
import { NameByValue } from '@/types';

type CCShiftEmptyCellProps = {
  dropdownList: NameByValue<CCShiftOptionType>[];
  onShiftChange: (shiftPayload?: CCShiftSelectPayload) => void;
};

export const CCShiftEmptyCell = ({ dropdownList, onShiftChange }: CCShiftEmptyCellProps) => {
  const elRef = useRef<HTMLButtonElement>(null);
  const [isOpen, toggleIsOpen] = useToggle(false);

  const onCellClick: MouseEventHandler<HTMLButtonElement> = useCallback(() => {
    toggleIsOpen();
  }, [toggleIsOpen]);

  return (
    <>
      <button
        ref={elRef}
        onClick={onCellClick}
        aria-label="add shift"
        className="flex items-center justify-center size-full rounded-lg text-base-20 border border-dashed border-base-20 opacity-0 focus:opacity-100 hover:opacity-100 transition cursor-pointer"
      >
        <MdAdd size={24} />
      </button>

      {isOpen && (
        <CCShiftCellDropdown
          triggerRef={elRef}
          isOpen={isOpen}
          onOpenChange={toggleIsOpen}
          onShiftChange={onShiftChange}
          optionList={dropdownList}
        />
      )}
    </>
  );
};
